<div *ngIf="!adjustment.DeleteAdjustment" [ngClass]="isAltRow ? 'alt-row p-10' : 'p-10'">
  <div class="mct-flex mct-row mct-justify-between mct-items-stretch"  >
    <div class="mct-flex mct-row mct-wrap mct-justify-between mct-items-stretch mct-flex-auto"   >
      <div    class="mb-27px mct-flex mct-col mct-gap-27 adj-edit-415px-gt-sm">
        <div class="mct-flex mct-row mct-wrap mct-gap-7"  >
          <div class="mct-flex mct-col" >
            <label>{{ 'invoices.invoice-builder.adjustments-tab.adjustment-date' | translate | titlecase }}</label>
            <wl-date-selector ngDefaultControl name="adjustmentDate" [(ngModel)]="adjustment.AdjustmentDate"></wl-date-selector>
          </div>
          <div class="mct-flex mct-col" >
            <label>{{ 'invoices.invoice-builder.adjustments-tab.apply-date' | translate | titlecase }}</label>
            <wl-date-selector
              name="applyDate"
              ngDefaultControl
              [(ngModel)]="adjustment.ApplyDate"
              [disabled]="adjustment.Posted"
            ></wl-date-selector>
          </div>
        </div>
        <div>
          <label>{{ 'invoices.invoice-builder.adjustments-tab.adjustment-total' | translate | titlecase }}</label>
          <div class="p-inputgroup">
            <button pButton type="button" class="atlas-input-addon" (click)="flipAdjustmentSign()">{{ adjustmentSign }}</button>
            <span class="atlas-input-addon">$</span>
            <input pInputText [(ngModel)]="adjustment.AdjustmentAmount" type="number" [disabled]="adjustment.Posted" />
          </div>
        </div>
        <div class="mct-flex mct-row mct-wrap mct-gap-7"  >
          <div class="adj-edit-204px" >
            <label>{{ 'invoices.invoice-builder.adjustments-tab.debit-account' | translate | titlecase }}</label>
            <input pInputText [disabled]="true" [(ngModel)]="debitAccount" />
          </div>
          <div class="adj-edit-204px" >
            <label>{{ 'invoices.invoice-builder.adjustments-tab.credit-account' | translate | titlecase }}</label>
            <input pInputText [disabled]="true" [(ngModel)]="creditAccount" />
          </div>
        </div>
      </div>
      <div class="mct-flex mct-col mct-gap-27 adj-edit-40pct-gt-sm"   >
        <div>
          <label>{{ 'invoices.invoice-builder.adjustments-tab.adjustment-type' | translate | titlecase }}</label>
          <p-select
            placeholder="{{ 'invoices.invoice-builder.select-label' | translate }}"
            [options]="adjustmentTypeItems"
            [style]="{ width: '100%' }"
            [(ngModel)]="adjustment.AdjustmentTypeId"
            (onChange)="updateAccounts()"
            [disabled]="adjustment.Posted"
          ></p-select>
        </div>
        <div>
          <label style="width: 100%">{{ 'invoices.invoice-builder.adjustments-tab.adjustment-descr' | translate | titlecase }}</label>
          <input type="text" [(ngModel)]="adjustment.Descr" class="form-input" style="width: 100%" />
        </div>
      </div>
    </div>
    <div class="ml-27 px mct-flex-none" >
      <label style="width: 100%">{{ 'invoices.invoice-builder.adjustments-tab.adjustment-id' | translate }}</label>
      <input [disabled]="true" [ngModel]="adjustment.AdjustmentId" />
    </div>
  </div>
  <hr style="color: #ececec" />
  <ng-container *ngIf="adjustment.InvoiceLineItemId > 0">
    <div class="adjustment-row-container mv-10 adjustment-labels">
      <span>{{ 'invoices.invoice-builder.adjustments-tab.adjustment-amount' | translate | titlecase }}</span>
      <span>{{ 'invoices.invoice-builder.adjustments-tab.line-item-descr' | translate | titlecase }}</span>
      <span>{{ 'invoices.invoice-builder.adjustments-tab.line-item-amount' | translate | titlecase }}</span>
      <span>{{ 'invoices.invoice-builder.adjustments-tab.line-item-id' | translate }}</span>
    </div>
    <div class="adjustment-row-container mv-10">
      <span type="number">{{ adjustment.AdjustmentAmount | currency : 'USD' : 'symbol' }}</span>
      <span>
        {{ !lineItem.Descr && lineItem?.ItemNum && allRevenueItems?.length ? getItemDescription(lineItem?.ItemNum) : lineItem.Descr }}
      </span>
      <span> {{ lineItem.Amount | currency }} </span>
      <span> {{ lineItem.LineItemId }} </span>
    </div>
  </ng-container>
  <ng-container *ngIf="adjustment.PaymentId > 0">
    <div class="payment-adjustment-row-container mv-10 adjustment-labels">
      <span>{{ 'invoices.invoice-builder.adjustments-tab.adjustment-amount' | translate | titlecase }}</span>
      <span>{{ 'invoices.invoice-builder.adjustments-tab.description' | translate | titlecase }}</span>
      <span>{{ 'invoices.invoice-builder.adjustments-tab.payment-amount' | translate | titlecase }}</span>
      <span>{{ 'invoices.invoice-builder.adjustments-tab.payment-id' | translate | titlecase }}</span>
      <span>{{ 'invoices.invoice-builder.adjustments-tab.payment-header-id' | translate | titlecase }}</span>
    </div>
    <div class="payment-adjustment-row-container mv-10">
      <span type="number">{{ adjustment.AdjustmentAmount | currency : 'USD' : 'symbol' }}</span>
      <span> {{ payment.PaymentType }} </span>
      <span> {{ payment.Amount | currency }} </span>
      <span> {{ payment.PaymentID }} </span>
      <span> {{ payment.PaymentHeaderID }} </span>
    </div>
  </ng-container>
  <div class="mct-flex mct-row mct-justify-end mct-items-center"  >
    <span *ngIf="adjustment.Posted" class="card-field-label"
      >{{ 'invoices.invoice-builder.adjustments-tab.adjustment-posted' | translate | titlecase }}
      {{ adjustment.DatePosted | date : 'MM/dd/yyyy' }}</span
    >&nbsp;
    <button pButton type="button" class="btn btn-danger" (click)="deleteAdjustment()" [disabled]="adjustment.Posted">
      <i class="pi pi-times"></i>{{ 'invoices.invoice-builder.adjustments-tab.remove-adjustment' | translate | uppercase }}
    </button>
  </div>
  <div class="mb-7">
    <hr />
  </div>
</div>
